<template>
  <div>
    <Nav />
    <Banner :title="title" />

    <div class="posts">
      <div class="container">
        <div class="row" v-if="!Object.keys(selectedGallery).length">
          <template v-if="items.length">
            <template v-for="(item, index) in items">
              <div
                v-if="item"
                :key="title + '-' + index"
                class="col-sm-12 col-md-4 col-lg-4"
              >
                <div class="gallery" @click="selectedGallery = item">
                  <h3 class="text-center">{{ item.title | niceTitle }}</h3>
                  <img :src="getImage(item.images[0].file)" />
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="text-center py-5">
              <p>
                There aren't any galleries to display. Please check back again
                later!
              </p>
            </div>
          </template>
        </div>
        <div class="row" v-else>
          <div class="col-12 mb-3 text-right">
            <button class="btn btn-primary" @click="selectedGallery = {}">
              <i class="fas fa-left-arrow"></i> Back
            </button>
          </div>
          <template v-for="(image, index) in selectedGallery.images">
            <div
              v-if="image"
              :key="title + '-' + index"
              class="col-sm-12 col-md-4 col-lg-4"
            >
              <div class="gallery-photo">
                <img
                  :src="getImage(image.file)"
                  :alt="image.alt"
                  @click="() => lightBox(image, selectedGallery.images, index)"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="lightBox" v-if="showLightBox && lightBoxImage">
      <span class="close-btn fa-2x" @click="lightBoxImage = null">
        <i class="fas fa-times"></i>
      </span>
      <div class="lightBoxImage">
        <transition name="fade" mode="out-in" key="title">
          <h3 class="text-center">{{ lightBoxImage.title }}</h3>
        </transition>
        <transition name="fade" mode="out-in" key="image">
          <img :src="getImage(lightBoxImage.file)" :alt="lightBoxImage.alt" />
        </transition>
        <span class="left-arrow" @click="prevImage">
          <i class="fas fa-arrow-left fa-2x"></i>
        </span>
        <span class="right-arrow">
          <i class="fas fa-arrow-right fa-2x" @click="nextImage"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import axios from "axios";
import moment from "moment";


export default {
  name: "Galleries",
  components: {
    Banner: Banner
  },
  props: {
    title: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({
    items: [],
    selectedGallery: {},
    showLightBox: false,
    lightBoxImage: null,
    lightBoxSlides: [],
    lightBoxIndex: 0
  }),
  created() {
    this.getItems();
  },
  methods: {
    nextImage() {
      if (this.lightBoxIndex < this.lightBoxSlides.length - 1)
        this.lightBoxIndex += 1;
      else this.lightBoxIndex = 0;
      this.lightBoxImage = this.lightBoxSlides[this.lightBoxIndex];
    },
    prevImage() {
      if (this.lightBoxIndex > 0) this.lightBoxIndex -= 1;
      else this.lightBoxIndex = this.lightBoxSlides.length - 1;
      this.lightBoxImage = this.lightBoxSlides[this.lightBoxIndex];
    },
    lightBox(image, slides, index) {
      this.showLightBox = true;
      this.lightBoxImage = image;
      this.lightBoxSlides = slides;
      this.lightBoxIndex = index;
    },
    getFile(value) {
      return process.env.VUE_APP_PDFS + value;
    },
    getImage(value) {
      return process.env.VUE_APP_IMAGES + value;
    },
    getItems() {
      axios
        .get(process.env.VUE_APP_SERVER + "galleries")
        .then(async res => {
          if (res.data) {
            this.items = res.data.result;
            this.items = await Promise.all(
              this.items.map(async gallery => {
                const images = await axios.get(
                  process.env.VUE_APP_SERVER + "gallery-photos/" + gallery.id
                );
                if (images.data.result) {
                  gallery["images"] = images.data.result;
                } else {
                  console.error(images.data.message, images.data.error);
                }
                return gallery;
              })
            );
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  filters: {
    niceDate(value) {
      return moment.utc(value).format("MMM Do YYYY");
    },
    niceTitle(value) {
      if (value.indexOf(" ") > -1) {
        return value
          .split(" ")
          .map(w => {
            return w[0].toUpperCase() + w.substring(1);
          })
          .join(" ");
      } else {
        return value[0].toUpperCase() + value.substring(1);
      }
    }
  }
};
</script>

<style lang="scss">
.search-item {
  border: solid 1px #ccc;
  border-radius: 20px;
  padding: 0.45rem;
  padding-left: 1rem;
  &:focus {
    outline: none;
  }
}

.search-icon {
  top: 12px;
  left: 168px;
  color: #ccc;
}

.posts {
  padding: 3rem 0;

  .post-image {
    margin: 0 0 1rem;
    max-height: 165px;
    overflow: hidden;

    margin-bottom: 1rem;

    img {
      position: relative;
      width: 110%;
      left: -5%;
      top: -5%;
    }
  }
}

.post-hero {
  background-size: 100%;
  background-position: 50%;
  min-height: 200px;
  h3 {
    padding-top: 4rem;
  }
  h4 {
    padding-bottom: 3rem;
  }
  h3,
  h4 {
    text-shadow: 0 0 5px #000;
    color: #fff;
  }
}

.post-content {
  min-height: 70vh;
  .col {
    min-height: 100%;
  }
}

.back-btn {
  text-align: right;
}

.filename {
  position: relative;
  bottom: 0.35rem;
}

.gallery {
  overflow: hidden;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc;
  border-radius: 5px;
  max-height: 300px;
  position: relative;
  cursor: pointer;

  h3 {
    padding: 0.5rem 0;
    width: 100%;
    // position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-shadow: 0 0 5px #000;
  }

  img {
    width: 100%;
  }
}
.gallery-photo {
  overflow: hidden;
  padding: 1rem;
  border: solid 1px #ccc;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;

  img {
    width: 100%;
    height: auto;
  }
}

.lightBox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 99;

  .close-btn {
    position: fixed;
    right: 1rem;
    top: 1rem;
    color: #fff;
    text-shadow: 0 0 5px #000;
    cursor: pointer;
    transition: color 0.25s ease;

    &:hover {
      color: blue;
    }
  }

  .lightBoxImage {
    height: 80vh !important;
    width: 100%;
    margin: 5% auto;

    h3 {
      text-align: center;
      padding: 1rem 0;
      margin: 0;
      width: 100%;
      color: #fff !important;
      text-shadow: 0 0 5px #000 !important;
    }

    img {
      width: 70% !important;
      min-width: 300px;
      margin: 0 auto;
      display: block;
    }

    .left-arrow,
    .right-arrow {
      position: absolute;
      color: #fff !important;
      text-shadow: 0 0 5px #000 !important;
      top: calc(50% - 0.5rem);

      &:hover {
        color: blue;
      }
    }

    .left-arrow {
      left: 0.5rem;
    }

    .right-arrow {
      right: 0.5rem;
    }
  }
}
</style>
